import { byMedia } from '../helpers/media';
export const directionMap = new Map();
directionMap.set('ltr', 'row');
directionMap.set('rtl', 'row-reverse');
directionMap.set('ttb', 'column');
directionMap.set('btt', 'column-reverse');
export const directionKeys = ['ltr', 'rtl', 'ttb', 'btt'];
export const flexDirection = byMedia(value => `flex-direction: ${directionMap.get(value) || value};`);